/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Preview_Error_TitleInputs */

const cs_builder_preview_error_title = /** @type {(inputs: Builder_Preview_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled selhal`)
};

const en_builder_preview_error_title = /** @type {(inputs: Builder_Preview_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview failed`)
};

/**
* | output |
* | --- |
* | "Preview failed" |
*
* @param {Builder_Preview_Error_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_preview_error_title = /** @type {((inputs?: Builder_Preview_Error_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Preview_Error_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_preview_error_title(inputs)
	return cs_builder_preview_error_title(inputs)
});